module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"controls":{"lastUpdated":"Last updated on","unkownLanguage":"Unkown language"}},"cs":{"controls":{"lastUpdated":"Naposledy upraveno","unkownLanguage":"Neznámý jazyk"}}}')
  delete Component.options._Ctor
}
